import script from "./generateList.vue?vue&type=script&setup=true&lang=js"
export * from "./generateList.vue?vue&type=script&setup=true&lang=js"

import "./generateList.vue?vue&type=style&index=0&id=6c2e5128&lang=css"
import "./generateList.vue?vue&type=style&index=1&id=6c2e5128&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c2e5128"]])

export default __exports__